module.exports = __webpack_public_path__ + "img/shipping.2ff1d382.svg";